import { useState, useMemo } from 'react';

export function useSortableFilterable(data, defaultSort = '', defaultDir = 'asc') {
  const [sortColumn, setSortColumn] = useState(defaultSort);
  const [sortDir, setSortDir] = useState(defaultDir);
  const [searchQuery, setSearchQuery] = useState('');

  const handleSort = (column) => {
    if (sortColumn === column) {
      setSortDir(prev => prev === 'asc' ? 'desc' : 'asc');
    } else {
      setSortColumn(column);
      setSortDir('asc');
    }
  };

  const sortedData = useMemo(() => {
    if (!sortColumn || !data) return data || [];
    return [...data].sort((a, b) => {
      const aVal = a[sortColumn];
      const bVal = b[sortColumn];
      if (aVal == null && bVal == null) return 0;
      if (aVal == null) return 1;
      if (bVal == null) return -1;
      if (typeof aVal === 'string') {
        const cmp = aVal.localeCompare(bVal, undefined, { sensitivity: 'base' });
        return sortDir === 'asc' ? cmp : -cmp;
      }
      if (typeof aVal === 'number') {
        return sortDir === 'asc' ? aVal - bVal : bVal - aVal;
      }
      return 0;
    });
  }, [data, sortColumn, sortDir]);

  return { sortColumn, sortDir, handleSort, searchQuery, setSearchQuery, sortedData };
}
